import { useState, useEffect } from "react";
import { Container } from "./Container";
import { ItemCard } from "./ItemCard";
import { getDashboardData } from "../../../../Api/admin";
import useAuth from "../../../../Hooks/useAuth";

export const Home = () => {
    const { auth } = useAuth();
    const [total, setTotal] = useState({
        lembaga: 0,
        prestasi: {
            semua: 0,
            bulan: 0,
            tahun: 0,
        },
    });

    const [leaderboard, setLeaderboard] = useState({
        bulan: "",
        tahun: "",
    });

    const getAllData = async () => {
        let result = await getDashboardData();
        let data = result.data.data[0];

        if (result?.status && result?.data) {
            setTotal({
                lembaga: data.total_users,
                prestasi: {
                    semua: data.total_achievement,
                    bulan: data.total_achievement_monthly,
                    tahun: data.total_achievement_yearly,
                },
            });

            setLeaderboard({
                bulan: data.top_school_monthly,
                tahun: data.top_school_yearly,
            });
        }
    };

    useEffect(() => {
        getAllData();
    }, []);

    return (
        <Container>
            {auth && auth?.role === "admin" ? (
                <>
                    <ItemCard
                        title="Total Lembaga Terdaftar"
                        total={total.lembaga?.toLocaleString("id-ID")}
                        icon="school"
                        bg="bg-green-400"
                    />
                    <ItemCard
                        title="Total Semua Prestasi"
                        total={total.prestasi.semua?.toLocaleString("id-ID")}
                        icon="trophy"
                        bg="bg-amber-400"
                    />
                    <ItemCard
                        title="Total Prestasi Bulan Ini"
                        total={total.prestasi.bulan?.toLocaleString("id-ID")}
                        icon="trophy"
                        bg="bg-red-400"
                    />
                    <ItemCard
                        title="Total Prestasi Tahun Ini"
                        total={total.prestasi.tahun?.toLocaleString("id-ID")}
                        icon="rewarded_ads"
                        bg="bg-purple-400"
                    />
                    <ItemCard
                        title="Prestasi Terbanyak Bulan Ini"
                        total={leaderboard.bulan || "N/A"}
                        icon="social_leaderboard"
                        bg="bg-orange-400"
                    />
                    <ItemCard
                        title="Prestasi Terbanyak Tahun Ini"
                        total={leaderboard.tahun || "N/A"}
                        icon="social_leaderboard"
                        bg="bg-slate-400"
                    />
                </>
            ) : (
                <>
                    <ItemCard
                        total={`Welcome | ${auth.school_name} 👋`}
                        icon="waving_hand"
                        bg="bg-green-400"
                    />
                    <ItemCard
                        title="Username"
                        total={auth.username}
                        icon="person"
                        bg="bg-amber-400"
                    />
                    <ItemCard
                        title="Nama Lembaga"
                        total={auth.school_name}
                        icon="school"
                        bg="bg-red-400"
                    />
                    <ItemCard
                        title="Id Lembaga"
                        total={auth.id}
                        icon="badge"
                        bg="bg-purple-400"
                    />
                </>
            )}
        </Container>
    );
};
